import React, { useContext, useEffect, useState } from 'react'

import './pp.css';
import styles from './PopupBooks.module.scss';
import { useForm } from '../../hooks/useForm';
import { useAxiosPost } from '../../hooks/useSuscribir';
import { PopupContext } from '../../context/PopupContext';
import { useTranslation } from 'react-i18next';

const PopupBooks = ({ imgTemp, titleLeft, titleRigth }) => {

  const { visible, setVisible } = useContext(PopupContext)
  const [t, i18n] = useTranslation('global');

  const [formSubmitted, setFormSubmitted] = useState(false)
  const { formState, onInputChange, name, lastName, email, onResetForm } = useForm({
    names: '',
    lastName: '',
    email: ''
  });


  const notAllowedChars = ['"', '`', '=', ';', '[', ']', '{', '}', '/', '\\', '&', '<', '>', ':', '\''];



  const handleFormSubmitted = (value) => {
    setFormSubmitted(value);
  };

  const { data, isLoading, error } = useAxiosPost(
    formSubmitted ? 'https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/subscriber' : null,
    {
      subject: "¡Gracias por suscribirte al blog!",
      message: "Ahora puedes descargar el fragmento en el sig link",
      assets: "https://www.ricardosalinas.com/content/assets/img/libros/Mailing-Warmup12092022.jpg",
      isFeedback: true,
      url: "https://www.ricardosalinas.com/libro_negocios/descarga",
      name: name,
      lastName,
      email,
      origin: "Libro azul"
    },
    handleFormSubmitted);

  const onFormSubmit = (event) => {
    event.preventDefault();

    if (name.length <= 1 || lastName.length <= 1 || email.length <= 1) return;

    setFormSubmitted(true);
    setVisible(false);

    
    alert(t("pop-up.gracias"));

    setTimeout(() => {
      setVisible(false)
    }, 700);
    
  }

  useEffect(() => {

    if (data === undefined) {
      onResetForm();
    }
  }, [data]);





  return (
    <div className={`${styles.popup}`}>
      <div className={`${styles.popup__container}`}>    
        <div className="responsive-container only-desk">
          <p   className='text left'>{titleLeft}</p>
          <img   className="responsive-image" src={imgTemp} />
        </div>
        <div className="responsive-container">
          <p   className='text'>{titleRigth}</p>
          <div className={`${styles.popup__close}`}>
            <button className='close-button' onClick={() => { setVisible(false) }}>
            </button>
          </div>
          <form className={styles.form__popup}
            onSubmit={onFormSubmit}>
            <div className={`${styles.form__popup__group}`}>
              <label className={styles.label__popup} >{t('forms.name')}</label>
              <input type="text" name="name" value={name} className={`${styles.input_popup}`} onChange={onInputChange} />
            </div>
            <div className={`${styles.form__popup__group}`}>
              <label className={styles.label__popup} >{t('forms.last_name')}</label>
              <input type="text" name="lastName" value={lastName} className={`${styles.input_popup}`} onChange={onInputChange} />
            </div>
            <div className={`${styles.form__popup__group}`}>
              <label className={styles.label__popup} >{t('forms.email')}</label>
              <input type="email" name="email" value={email} className={`${styles.input_popup}`} onChange={onInputChange} />
            </div>
            <div className={`${styles.form__popup__group}`}>
              <label>
                <input className={`${styles.form__popup__group__input}`} type="checkbox" name="acept" />  {t('forms.accept')}
              </label>
            </div>
            <div className={`${styles.form__popup__group} ${styles.form__popup__group__center}`}>
                {isLoading ? (
                  <span style={{ display: visible ? 'inline' : 'none' }}>{t('forms.sending')}...</span>
                ) : (
                  <button className={`${styles.btn} ${styles.btn_yellow}`} onClick={handleFormSubmitted}>{t('general.suscribirse')}</button>
                )}    
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}


export default PopupBooks;